import React, { Component } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { SliderWrapper } from 'components/digitalNomad/ImageComparisonSlider.style.js';

class ImageComparisonSlider extends Component {

  state = {
    min: 0,
    max: 100,
    value: this.props.sliderStart,
    width: null,
    height: null
  }

  saveRef = (ref) => this.containerNode = ref;

  measure() {
    const {clientWidth} = this.containerNode;

    this.setState({
      width: clientWidth,
    })
  }

  componentDidMount() {
    this.measure();
  }

  componentDidUpdate() {
    this.measure();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.width !== nextState.width ||
      this.state.height !== nextState.height ||
      this.state.value !== nextState.value
    )
  }

  onSliderChange = (value) => {
    this.setState({
      value,
    });
  }

  render() {
    const {width, value} = this.state;
    return (
      <SliderWrapper>
        <div ref={this.saveRef} style={{ width: '100%', position: 'relative' }}>
          <div style={{ width: value + '%', overflow: 'hidden' }}>
            <img src={require(`../../${this.props.srcBefore}`)} alt="" style={{ width: width + 'px'}} />
            <img src={require(`../../${this.props.srcAfter}`)} alt="" style={{ width: width + 'px'}} />
          </div>
          <Slider defaultValue={value} onChange={this.onSliderChange} />
        </div>
      </SliderWrapper>
    );
  }
}

export default ImageComparisonSlider;



// WEBPACK FOOTER //
// ./src/components/digitalNomad/ImageComparisonSlider.js